// src/components/WorshipSchedule.jsx

import React, { useState } from 'react';
// import { FaCalendarDay, FaUsers } from 'react-icons/fa';

// Data jadwal ibadah umum
const generalSchedule = [
    { day: 'Minggu Pagi', time: '06.00 WITA', service: 'Ibadah Umum' },
    { day: 'Minggu Pagi', time: '09.00 WITA', service: 'Ibadah Umum' },
    { day: 'Minggu Sore', time: '18.00 WITA', service: 'Ibadah Umum' },
    { day: 'Rabu', time: '19.00 WITA', service: 'Ibadah Keluarga' },
];

// Data jadwal ibadah Pelkat
const pelkatSchedule = [
    { name: 'Pelayanan Anak (PA - IHMPA)', day: 'Minggu', time: '09.00 WITA', english: 'Children Sunday Service' },
    { name: 'Persekutuan Teruna (PT - IHMPT)', day: 'Minggu', time: '07.00 WITA', english: 'Teenage Sunday Service' },
    { name: 'Gerakan Pemuda (GP)', day: 'Jumat', time: '19.30 WITA', english: 'Youth Friday Service' },
    { name: 'Persekutuan Kaum Perempuan (PKP)', day: 'Jumat', time: '17.30 WITA', english: 'Women Friday Service' },
    { name: 'Persekutuan Kaum Bapak (PKB)', day: 'Jumat', time: '19.30 WITA', english: 'Men Friday Service' },
    { name: 'Persekutuan Kaum Lanjut Usia (PKLU)', day: 'Sabtu Akhir Bulan', time: '10.00 WITA', english: 'Elderly Saturday Service' },
];

const WorshipSchedule = () => {
    const [activeTab, setActiveTab] = useState('umum'); // State untuk tab yang aktif

    const tabClasses = (tabName) => (
        `flex-1 py-2 px-4 text-sm md:text-base font-semibold transition-all duration-300 ease-in-out cursor-pointer
        ${activeTab === tabName
            ? 'bg-blue-700 text-white'
            : 'bg-white text-gray-700 hover:bg-gray-50'
        }`
    );

    return (
        <section className=" overflow-hidden h-full">
            {/* Tab Navigation */}
            <div className="flex bg-white shadow-sm p-1 rounded-t-xl">
                <button
                    onClick={() => setActiveTab('umum')}
                    className={tabClasses('umum')}
                >
                    Ibadah Umum
                </button>
                <button
                    onClick={() => setActiveTab('pelkat')}
                    className={tabClasses('pelkat')}
                >
                    Ibadah Pelkat
                </button>
            </div>

            {/* Konten Tab */}
            <div className="space-y-4 ">
                {activeTab === 'umum' && (
                    <div className="bg-white rounded-lg p-2 shadow-sm">
                        <h3 className="text-lg font-bold text-gray-800 pb-2 mb-2 border-b border-gray-200 items-center space-x-2">
                            {/* <FaCalendarDay className="text-blue-500" /> */}
                            <span>JADWAL IBADAH UMUM</span>
                        </h3>
                        <ul className="space-y-2">
                            {generalSchedule.map((item, index) => (
                                <li key={index} className="flex justify-between items-center bg-gray-100 p-3 rounded-lg">
                                    <div className="text-left">
                                        <p className="font-semibold text-gray-900 text-base">{item.day}</p>
                                        <p className="text-xs text-blue-600">{item.service}</p>
                                    </div>
                                    <div className="text-right">
                                        <span className="font-bold text-base text-gray-800">{item.time}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {activeTab === 'pelkat' && (
                    <div className="bg-white rounded-lg p-2 shadow-sm">
                        <h3 className="text-lg font-bold text-gray-800 pb-2 mb-2 border-b border-gray-200 items-center space-x-2">
                            {/* <FaUsers className="text-blue-500" /> */}
                            <span>JADWAL IBADAH PELKAT</span>
                        </h3>
                        <ul className="space-y-2">
                            {pelkatSchedule.map((item, index) => (
                                <li key={index} className="flex justify-between items-center bg-gray-100 p-3 rounded-lg">
                                    <div className="text-left">
                                        <p className="font-semibold text-gray-900 text-base">{item.name}</p>
                                        <p className="text-xs text-gray-500">{item.english}</p>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-gray-500 text-xs">{item.day}</p>
                                        <span className="font-bold text-base text-gray-800">{item.time}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </section>
    );
};

export default WorshipSchedule;